var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDivider3 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 21,
    fill: "none",
    viewBox: "0 0 19 21",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5DEEB",
    d: "M7.26 5.915a24.6 24.6 0 0 0-2.749 2.813c-.85-1.692-1.436-3.497-1.676-5.299 1.413.628 2.935 1.477 4.426 2.486m2.224 1.66c1.31 1.073 2.531 2.26 3.547 3.527a17 17 0 0 1-3.547 3.704 17 17 0 0 1-3.548-3.704c1.016-1.267 2.239-2.454 3.548-3.528m6.647-4.146c-.239 1.802-.825 3.607-1.675 5.299a24.6 24.6 0 0 0-2.749-2.813c1.49-1.01 3.011-1.858 4.424-2.486m-4.216 12.878c.986-.85 1.883-1.81 2.696-2.835.703 1.295 1.166 2.635 1.265 3.99-1.385-.142-2.712-.553-3.961-1.155m-8.823 1.155c.098-1.355.56-2.695 1.264-3.99a21 21 0 0 0 2.696 2.835c-1.248.602-2.575 1.013-3.96 1.155M.099 20.104c1.686 1.358 7.43-.844 9.137-1.857.085-.05.164-.11.248-.163.084.053.163.113.247.163 1.706 1.013 7.45 3.215 9.137 1.857.237-.19.275-4.235-2.652-8.94.493-.82.942-1.663 1.32-2.53.963-2.208 1.44-4.672 1.431-7.085 0-.202-.04-.38-.105-.534-.17-.666-.777-1.242-1.602-.926-3.115 1.195-5.669 2.594-7.776 4.085C7.377 2.683 4.822 1.284 1.708.089.882-.227.275.35.105 1.015A1.4 1.4 0 0 0 0 1.549C-.009 3.962.47 6.426 1.43 8.634c.38.867.828 1.71 1.32 2.53C-.174 15.87-.137 19.914.1 20.104"
  })));
};
export default SvgDivider3;